import React, { useState } from 'react';
import { AlertTriangle, CheckCircle, Info, X } from 'lucide-react';
const allAlerts = [{
  id: 1,
  type: 'warning',
  title: 'Accumulation prévue',
  message: 'Secteur Nord: 6-8 cm attendus dans 2h',
  time: 'Il y a 5 min'
}, {
  id: 2,
  type: 'info',
  title: 'Rang publié',
  message: 'Scénario P50 publié pour Franchise MTL-Est',
  time: 'Il y a 15 min'
}, {
  id: 3,
  type: 'success',
  title: 'SLA respecté',
  message: 'Site #1247 terminé en 1h45 (SLA: 2h)',
  time: 'Il y a 23 min'
}, {
  id: 4,
  type: 'warning',
  title: 'Retard détecté',
  message: 'Site #1532 en retard de 15 min',
  time: 'Il y a 1h'
}];
export function AlertsPanel() {
  const [filter, setFilter] = useState<string>('all');
  const [alerts, setAlerts] = useState(allAlerts);
  const filteredAlerts = alerts.filter(alert => filter === 'all' || alert.type === filter);
  const dismissAlert = (id: number) => {
    setAlerts(alerts.filter(alert => alert.id !== id));
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-14">
      <div className="flex items-center justify-between mb-4" data-id="element-15">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-16">
          Alertes récentes
        </h2>
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-17">
          Voir tout
        </button>
      </div>
      {/* Filter Buttons */}
      <div className="flex space-x-2 mb-4" data-id="element-18">
        <button onClick={() => setFilter('all')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${filter === 'all' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-19">
          Toutes
        </button>
        <button onClick={() => setFilter('warning')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${filter === 'warning' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-20">
          Avertissements
        </button>
        <button onClick={() => setFilter('success')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${filter === 'success' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-21">
          Succès
        </button>
      </div>
      <div className="space-y-3" data-id="element-22">
        {filteredAlerts.map(alert => <div key={alert.id} className="group flex items-start space-x-3 p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors relative" data-id="element-23">
            {alert.type === 'warning' && <AlertTriangle className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" data-id="element-24" />}
            {alert.type === 'info' && <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" data-id="element-25" />}
            {alert.type === 'success' && <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-26" />}
            <div className="flex-1 min-w-0" data-id="element-27">
              <p className="text-sm font-medium text-gray-900" data-id="element-28">{alert.title}</p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-29">{alert.message}</p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-30">{alert.time}</p>
            </div>
            <button onClick={() => dismissAlert(alert.id)} className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-gray-200 rounded" data-id="element-31">
              <X className="w-4 h-4 text-gray-500" data-id="element-32" />
            </button>
          </div>)}
      </div>
    </div>;
}